
import { defineComponent } from "vue";
import ImageCard from "@/components/bono/ImageCard.vue";
import BonoHowItWorksStep from "./bonoHowItWorks/BonoHowItWorksStep.vue";

export default defineComponent({
  components: {
    ImageCard,
    BonoHowItWorksStep,
  },
  props: {
    withoutIcon: { type: Boolean },
  },
  setup() {
    return {
      baseURL: process.env.BASE_URL,
    };
  },
});
